import { isMesh } from './coalesce';

import * as THREE from 'three';

export const getSemiPoints = (node: THREE.Object3D) => {
  const points: THREE.Vector3[] = [];

  node.traverseVisible((child) => {
    if (isMesh(child) && /^Semi/.test(child.name)) {
      const box = new THREE.Box3().setFromObject(child);
      const center = box.getCenter(new THREE.Vector3());
      points.push(center);
    }
  });
  return points;
};
